import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from '../../shared/shared.module';
import { ThingTroubleshootingDialogComponent } from './thing-troubleshooting-dialog.component';
import { ThingTroubleshootingDynamicContentComponent } from './thing-troubleshooting-dynamic-content.component';
import { ThingTroubleshootingItemComponent } from './thing-troubleshooting-item.component';

/**
 * Reusable troubleshooting rendering components.
 * The legacy widget module and the standard event details dialog both consume this module.
 */
@NgModule({
    imports: [
        SharedModule,
        ReactiveFormsModule
    ],
    declarations: [
        ThingTroubleshootingDialogComponent,
        ThingTroubleshootingDynamicContentComponent,
        ThingTroubleshootingItemComponent
    ],
    exports: [
        ThingTroubleshootingDialogComponent,
        ThingTroubleshootingDynamicContentComponent,
        ThingTroubleshootingItemComponent
    ]
})
export class ThingTroubleshootingModule { }
